import React from "react"
import dayjs from "dayjs";

function ExternalUpdatesTable(props){

    const {data, dataKey, title, noElementsMessage} = props;
 
    return(
        <div style={{marginTop: "0.25rem", marginBottom: "0.25rem"}}>
        {
            data && data.length > 0 ?
                <>
                <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <span style={{marginBottom:"2px", fontWeight:"bold"}}>{title}</span>
                </div>
                    <table className="callTable">
                        <tbody>
                        {data.length>0&&data.map((e)=>{
                            return(
                            <tr className="callTableTr" key={e.callId}>
                                <td className="callTableTd" style={{backgroundColor:"#fcfcfc", marginRight:"0.75rem"}}>{e[dataKey]}</td>
                                <td className="callTableTd" style={{backgroundColor:"#fcfcfc", minWidth:"50px"}}>{dayjs(e.date).format("DD/MM/YYYY HH:mm:ss")}</td> 
                            </tr>)})
                        }
                        </tbody>
                    </table> 
                    </> :
                    <div style={{width:"100%"}}>
                       <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                            <span>{noElementsMessage}</span>
                        </div>
                </div>
            }
        </div>
            
    )
}

export {ExternalUpdatesTable}